import ajax from "../api/ajax";
import queryString from "query-string";
import {baseUrl} from "../api";
import {Modal} from "antd";
import subCode from "../pages/mobile/images/subcode.png";
import wx from "../pages/mobile/images/wx.png";
import React from "react";
const wx_url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx239460a0813ea627&redirect_uri="
const wx_ser_url= baseUrl.split("/").slice(0,3).join("/")+"/wechat"
//const wx_ser_url= "http://localhost:8000"+"/wechat"
const STORE_KEY="wxToken"
const storeToken=(token)=>{
    if(token && token.expiresIn){
        let expiresIn = token.expiresIn
        let dtNow = new Date()
        dtNow.setSeconds(dtNow.getSeconds()+expiresIn/2)
        let wxToken = Object.assign(token,{expireDt:dtNow})
        window.localStorage.setItem(STORE_KEY,JSON.stringify(wxToken))
    }
}
const readToken=()=>{
    let tokenStr = window.localStorage.getItem(STORE_KEY);
    if(tokenStr && JSON.parse(tokenStr)){
        let token = JSON.parse(tokenStr)
        let expireDt = new Date(token.expireDt)
        let dt = new Date()
        if(token.expireDt && expireDt.getTime()>dt.getTime()){
            return token
        }else{
            return {}
        }
    }
    return {}
}
const getWxUrl=(params=null)=>{
    let catUrl=""
    let wx_redirect_url = window.location.href
    if (params && JSON.stringify(params) !== '{}'){
        catUrl=queryString.stringify(this.subInfo)
    }
    wx_redirect_url = encodeURIComponent(wx_redirect_url+catUrl)
    wx_redirect_url = wx_url+wx_redirect_url+"&response_type=code&scope=snsapi_userinfo&state=a#wechat_redirect"

    return wx_redirect_url
}
const gotoWx=(params=null)=>{
    window.location.replace(getWxUrl(params))
}
const getToken=(code)=>{
    let result = ajax(wx_ser_url + "/token?code=" + code);
    return new Promise((resolve, reject) => {
        return result.then((resp) => {
            let info = Object.assign({}, resp.token, resp.user)
            if (resp && resp.token) {
                storeToken(info)
                resolve(readToken());
            }else {
                reject("code错误1")
            }
        }).catch((error) => {
            reject("code错误2")
        });
    })
}
const checkToken=(wxToken)=>{
    let token = wxToken.accessToken;
    let openId = wxToken.openid;
    let url=wx_ser_url+"/token/check?token="+token+"&openid="+openId
    let result = ajax(url);
    return new Promise((resolve, reject) => {
        return result.then((resp) => {
            console.log(wxToken,resp)
            if (resp.check) {
                //debug
                //wxToken.subscribe=1
                if(resp.user) {
                    wxToken.subscribe = resp.user.subscribe
                }
                resolve(wxToken);
            } else {
                gotoWx()
            }
        }).catch((error) => {
            gotoWx()
        });
    })
}
const getWxUserInfo=()=>{
    let wxToken = readToken();
    let token = wxToken.accessToken;
    let openId = wxToken.openid;
    if (token && openId) {
        return new Promise((resolve, reject) => {
            return checkToken(wxToken).then((wxToken)=>{
                resolve(wxToken);
            }).catch((error) => {
                gotoWx()
            });
        })
    } else {
        gotoWx()
        return Promise.reject(null)
    }
}
const handleWxCode=(props)=>{
    let query = queryString.parse(props.location.search)
    let code = query.code;
    if(code){
        if(code && code instanceof Array){
            code = code[0]
        }
        return new Promise((resolve, reject) => {
            return getToken(code).then((ret)=>{
                resolve(ret);
            }).catch((error) => {
                reject(null)
            }).finally(()=>{
                let query = queryString.parse(props.location.search)
                if(query&& query.code){
                    delete query.code;
                    delete query.state;
                    if (query && JSON.stringify(query) !== '{}'){
                        props.history.replace(props.location+"?"+queryString.stringify(query))
                    }else{
                        props.history.replace(props.location.pathname)
                    }
                }
            });
        })
    }else{
        return new Promise((resolve, reject) => {
            return getWxUserInfo().then((ret)=>{
                resolve(ret);
            }).catch((error) => {
                reject("获取微信信息")
            });
        })
    }
}
let showQr=false
const checkWxSub=()=>{
    getWxUserInfo().then((wxToken)=>{
        if(wxToken.subscribe!==1){
            if(!showQr) {
                showQr = true
                Modal.info({
                    icon: null,
                    centered: true,
                    okButtonProps: {style: {display: "none"}},
                    content: (
                        <div className='attention'>
                            <div className='attention-bg'>
                                <img src={subCode} alt='subCode'/>
                            </div>
                            <div className='attention-code'>
                                <img src={wx} alt='wx'/>
                            </div>
                        </div>
                    ),
                });
            }
            setTimeout(checkWxSub,2000)
        }else{
            Modal.destroyAll();
        }
    }).catch(()=>{

    })
}
export {handleWxCode,getWxUserInfo,checkWxSub,readToken}